import React, { SVGProps } from 'react';

const SvgSale2 = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg viewBox='0 0 24 24' className='svg-icon' {...props}>
			<g fill='none' fillRule='evenodd'>
				<path d='M0 0h24v24H0z' />
				<path
					fill='currentColor'
					opacity={0.3}
					d='M12 20.022l-3.527 1.707-1.604-3.575-3.799-.959 1.069-3.77-2.293-3.176 3.241-2.2.285-3.908 3.898.398L12 1.729l2.73 2.81 3.898-.398.285 3.907 3.241 2.201-2.293 3.177 1.069 3.769-3.8.96-1.603 3.574z'
				/>
				<path fill='currentColor' d='M14.09 8.603L8.36 14.7 9.71 16.05l5.728-6.099z' />
				<path
					d='M10.854 9.175a1.718 1.718 0 11-3.435.002 1.718 1.718 0 013.435-.002M14.864 16.622a1.719 1.719 0 110-3.437 1.719 1.719 0 010 3.437z'
					fill='currentColor'
					opacity={0.3}
				/>
			</g>
		</svg>
	);
};

export default SvgSale2;
